import React, { useContext } from "react";
import { Location } from "@reach/router";
import { Link } from "gatsby";
import { CustomI18nextContext } from "../../../contexts/CustomI18nextContext";

const LanguageSwitcher = ({ className }) => {
  const { t, lang, siteCountry } = useContext(CustomI18nextContext);

  return lang !== "en" && lang !== "au" ? (
    <Location>
      {({ location }) => {
        let navigateTo = location.pathname;
        if (lang === "th" || lang === "id") {
          navigateTo = navigateTo.replace(`/${lang}`, `/${lang}/en`);
        } else {
          navigateTo = navigateTo.replace(
            `/${siteCountry}/en`,
            `/${siteCountry}`
          );
        }

        return (
          <Link
            className={`lang-switch ml-3 ml-xl-4 ${className}`}
            to={navigateTo}
          >
            {t("common.languageSwitcher")}
          </Link>
        );
      }}
    </Location>
  ) : null;
};

export default LanguageSwitcher;
